import React from "react";

/**
 * Cause the component to re-render at a fixed interval.
 */
export function useIntervalUpdate(interval: number): void {
	const [_, forceUpdate] = React.useState(0);

	React.useEffect(() => {
		const intervalId = setInterval(() => forceUpdate(n => n + 1), interval);
		return () => clearInterval(intervalId);
	}, [interval]);
}
